import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/brand/brand/apps/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import { PropTableValues } from '../../src/components';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Note = makeShortcode("Note");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import {Timeline} from '@primer/react-brand'
`}</code></pre>
    <h2>{`Examples`}</h2>
    <Note mdxType="Note">
      <p>{`Timeline requires the `}<inlineCode parentName="p">{`dir`}</inlineCode>{` attribute to be set on the `}<inlineCode parentName="p">{`<html>`}</inlineCode>{` element to ensure the correct visual apperance of timeline items.`}</p>
    </Note>
    <h3>{`Default`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Timeline>
  <Timeline.Item>
    GitHub Codespaces offers a complete dev environment in seconds, so you can
    code, build, test, and open pull requests from any repo anywhere.
  </Timeline.Item>
  <Timeline.Item>
    GitHub Copilot is your AI pair programmer that empowers you to complete
    tasks 55% faster by turning natural language prompts into coding
    suggestions.
  </Timeline.Item>
  <Timeline.Item>
    GitHub Actions automates your build, test, and deployment workflow with
    simple and secure CI/CD.
  </Timeline.Item>
</Timeline>
`}</code></pre>
    <h3>{`With emphasis`}</h3>
    <p>{`Use an `}<inlineCode parentName="p">{`<em>`}</inlineCode>{` element within the timeline items to apply a duotone style and emphasize part of the text.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Timeline>
  <Timeline.Item>
    <em>GitHub Codespaces</em> offers a complete dev environment in seconds, so
    you can code, build, test, and open pull requests from any repo anywhere.
  </Timeline.Item>
  <Timeline.Item>
    <em>GitHub Copilot</em> is your AI pair programmer that empowers you to
    complete tasks 55% faster by turning natural language prompts into coding
    suggestions.
  </Timeline.Item>
  <Timeline.Item>
    <em>GitHub Actions</em> automates your build, test, and deployment workflow
    with simple and secure CI/CD.
  </Timeline.Item>
</Timeline>
`}</code></pre>
    <h3>{`Timeline`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`className`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets a custom class on the root element`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`children`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`Timeline.Item`}</inlineCode>{`, `}<inlineCode parentName="td">{`Timeline.Item[]`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Content to be displayed within the component`}</td>
        </tr>
      </tbody>
    </table>
    <h3>{`Timeline.Item`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`className`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets a custom class on the root element`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`children`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`React.ReactNode`}</inlineCode>{`, `}<inlineCode parentName="td">{`React.ReactNode[]`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Content to be displayed within the item.`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      